'use client';

import { useEffect } from 'react';
import Link from 'next/link';
import { reportError } from '../src/lib/errors/error-reporter.client';

export default function AppError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    reportError({
      level: 'error',
      source: 'frontend',
      context: 'app.error',
      message: error.message || 'Unerwarteter Fehler',
      stack: error.stack,
      metadata: { digest: error.digest },
    });
  }, [error]);

  return (
    <main className="grid min-h-screen place-items-center bg-[var(--k-color-bg-app)] px-6 py-12">
      <div className="max-w-lg text-center">
        <p className="text-xs font-bold uppercase tracking-[0.2em] text-[var(--k-color-danger)]">Fehler</p>
        <h1 className="mt-3 text-3xl font-bold tracking-tight text-[var(--k-color-text-primary)]">
          Etwas ist schiefgelaufen
        </h1>
        <p className="mt-4 text-sm text-[var(--k-color-text-secondary)]">
          Wir konnten diese Seite leider nicht laden. Bitte versuche es erneut.
        </p>
        {error.digest ? (
          <p className="mt-2 font-mono text-xs text-[var(--k-color-text-muted)]">
            Fehler-ID: {error.digest}
          </p>
        ) : null}
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <button
            type="button"
            onClick={reset}
            data-tour="error-retry"
            className="rounded-[var(--k-radius-md)] bg-[var(--k-color-accent)] px-4 py-2 text-sm font-bold text-white transition hover:brightness-110"
          >
            Erneut versuchen
          </button>
          <Link
            href="/dashboard"
            className="rounded-[var(--k-radius-md)] border border-[var(--k-color-border-default)] bg-[var(--k-color-surface)] px-4 py-2 text-sm font-semibold transition hover:border-[var(--k-color-border-strong)]"
          >
            Zum Dashboard
          </Link>
        </div>
      </div>
    </main>
  );
}